import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext({ logo_url: "" });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ logo_url: "" });
  useEffect(() => { api.settings().then(setSettings).catch(() => {}); }, []);
  return <SettingsContext.Provider value={{ settings, setSettings }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
